/**
 * 获取变量类型
 *
 * @param obj 需要辨别的变量
 * @returns 对象的类型
 */
export const type = (obj: unknown): string => {
  // oxlint-disable-next-line no-undefined
  if (obj === undefined) return "undefined";

  const objType = typeof obj;

  if (objType === "object") {
    // oxlint-disable-next-line eqeqeq
    if (obj === null) return "null";

    const match = /\[object (\w+)\]/u.exec(Object.prototype.toString.call(obj));

    return match ? match[1].toLowerCase() : "";
  }

  return objType;
};

// oxlint-disable-next-line typescript/ban-types, typescript/no-unsafe-function-type
export const isFunction = <T extends Function>(obj: unknown): obj is T => type(obj) === "function";
